export default __webpack_public_path__ + "static/media/Africa.fe3003e2.svg";